import {
  CampaignTypeEnum,
  UserImpactAggregates,
  ProfileSizes,
  User,
  Wordpress,
} from "@ecologi/shared";
import { ProfileHeaderSection } from "@ecologi/react-components/src/ProfilePage";

const { DeprecatedCard, DeprecatedCards } = ProfileHeaderSection;

type ProfileVariant = {
  bodyClass: string;
  headerSectionSize: ProfileSizes;
  isForestHidden?: boolean;
  profileTitle: { title: string; intro?: string };
  renderHeaderRow: (props: {
    isOwnProfile: boolean;
    numberOfTonnes: number;
    numberOfTrees: number;
    profile: User;
    projects: Wordpress.Project[];
    userImpactAggregates: UserImpactAggregates;
  }) => React.ReactNode;
};

export const ProfilesVariants: { [campaign: string]: ProfileVariant } = {
  [CampaignTypeEnum.WEAREALBERT]: {
    headerSectionSize: ProfileSizes.DEFAULT,
    bodyClass: "",
    profileTitle: {
      title: "",
    },
    isForestHidden: true,
    renderHeaderRow({
      numberOfTonnes,
      numberOfTrees,
      profile,
      projects,
      userImpactAggregates,
    }) {
      return (
        <DeprecatedCards>
          <DeprecatedCard
            user={profile}
            number={numberOfTonnes || 0}
            type="carbon"
            projects={projects}
            userImpactAggregates={userImpactAggregates}
          />
          <DeprecatedCard
            user={profile}
            number={numberOfTrees}
            type="trees"
            projects={projects}
            userImpactAggregates={userImpactAggregates}
          />
        </DeprecatedCards>
      );
    },
  },
  DEFAULT: {
    headerSectionSize: ProfileSizes.DEFAULT,
    bodyClass: "",
    profileTitle: { title: "" },
    renderHeaderRow: () => null,
  },
};
